import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Box,
    CircularProgress,
    Alert,
    List,
    ListItem,
    ListItemText,
    Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as XLSX from "xlsx";
import { pass } from "three/src/nodes/display/PassNode.js";


const Dropzone = styled("label")(({ theme }) => ({
    border: "2px dashed #1976d2",
    borderRadius: "15px",
    backgroundColor: "#f5f5f5",
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    transition: "0.2s",
    textAlign: "center",
    padding: "20px",
    "&:hover": {
        backgroundColor: "#e3f2fd",
    },
    "& input": {
        position: "absolute",
        inset: 0,
        opacity: 0,
        cursor: "pointer",
    },
}));

const ImportUsersDialog = ({ token, open, onClose, selectedGroupCode }) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [dragActive, setDragActive] = useState(false);

    useEffect(() => {
        if (!open) {
            setResult(null);
            setError(null);
            setLoading(false);
            setFileName(null);
        }
    }, [open]);

    const validateFile = (file) => {
        if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
            setError("Dozwolone są tylko pliki Excel (.xlsx, .xls)");
            return false;
        }
        return true;
    };

    // const uploadFile = async (file) => {
    //     if (!validateFile(file)) return;

    //     setLoading(true);
    //     setError(null);
    //     setResult(null);
    //     setFileName(file.name);

    //     const formData = new FormData();
    //     formData.append("file", file);
    //     formData.append('groupCode', selectedGroupCode);

    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_API_URL}/users-permissions/users/import-group/${selectedGroupCode}`,
    //             formData,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );

    //         setResult(response.data);
    //     } catch (err) {
    //         setError(err?.response?.data?.message || "Import nie powiódł się");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // const uploadFile = async (file, selectedGroupCode) => {
    //     if (!validateFile(file)) return;

    //     setLoading(true);
    //     setError(null);
    //     setResult(null);
    //     setFileName(file.name);

    //     // console.log('selectedGroupCode', selectedGroupCode)

    //     // const response = await axios.get(`{{SERVER}}/events-schedule/events-in-groups?groups=${selectedGroupCode}&groups=${selectedGroupCode}`);

    //     //     {{SERVER}}/events-schedule/300129fa-6990-4e97-9a5e-e1b3bda37863/join

    //     const data = await file.arrayBuffer();
    //     const workbook = XLSX.read(data);
    //     const sheetName = workbook.SheetNames[0];
    //     const sheet = workbook.Sheets[sheetName];
    //     const users = XLSX.utils.sheet_to_json(sheet);

    //     console.log('users', users)

    //     const formattedUsers = [...users.map(user => ({
    //         email: user.Email,
    //         username: user.UserName,
    //     }))
    //     ]


    //     const formData = new FormData();
    //     formData.append("file", file);
    //     formData.append("groupCode", selectedGroupCode);
    //     // formData.append("users", JSON.stringify(users));
    //     formData.append("users", JSON.stringify(formattedUsers));

    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_API_URL}/users-permissions/users/import-group/${selectedGroupCode}`,
    //             formData,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     "Content-Type": "multipart/form-data",
    //                 },
    //             }
    //         );

    //         console.log('response.data', response.data)

    //         setResult(response.data);
    //     } catch (err) {
    //         setError(err?.response?.data?.message || "Import nie powiódł się");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // const uploadFile = async (file, selectedGroupCode) => {
    //     if (!validateFile(file)) return;

    //     setLoading(true);
    //     setError(null);
    //     setResult(null);
    //     setFileName(file.name);

    //     try {
    //         const eventsResponse = await axios.get(
    //             `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/events-in-groups?groups=${selectedGroupCode}&groups=${selectedGroupCode}`,
    //             { headers: { Authorization: `Bearer ${token}` } }
    //         );
    //         const events = eventsResponse.data;
    //         console.log('events for group', events);

    //         const data = await file.arrayBuffer();
    //         const workbook = XLSX.read(data);
    //         const sheetName = workbook.SheetNames[0];
    //         const sheet = workbook.Sheets[sheetName];
    //         const users = XLSX.utils.sheet_to_json(sheet);

    //         const formattedUsers = users.map(user => ({
    //             email: user.Email,
    //             username: user.UserName,
    //             id: user.Id,
    //         }));

    //         console.log('formattedUsers', formattedUsers)

    //         const formData = new FormData();
    //         formData.append("file", file);
    //         formData.append("groupCode", selectedGroupCode);
    //         formData.append("users", JSON.stringify(formattedUsers));

    //         const importResponse = await axios.post(
    //             `${process.env.REACT_APP_API_URL}/users-permissions/users/import-group/${selectedGroupCode}`,
    //             formData,
    //             { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    //         );
    //         console.log('import response', importResponse.data);

    //         for (const event of events) {
    //             await axios.post(
    //                 `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${event.id}/join-many`,
    //                 { userIds: formattedUsers.map(u => u.id) },
    //                 { headers: { Authorization: `Bearer ${token}` } }
    //             );
    //         }

    //         setResult({ import: importResponse.data, eventsJoined: events.length });
    //     } catch (err) {
    //         setError(err?.response?.data?.message || "Import nie powiódł się");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const uploadFile = async (file, selectedGroupCode) => {
        if (!validateFile(file)) return;

        setLoading(true);
        setError(null);
        setResult(null);
        setFileName(file.name);

        try {
            const eventsResponse = await axios.get(
                `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/events-in-groups?groups=${selectedGroupCode}&groups=${selectedGroupCode}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const events = eventsResponse.data;

            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data);
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const users = XLSX.utils.sheet_to_json(sheet);

            const formattedUsers = users.map(user => ({
                email: user.Email,
                username: user.UserName,
                password: user.Password,
            }));

            console.log('formattedUsers', formattedUsers);

            const formData = new FormData();
            formData.append("file", file);
            formData.append("groupCode", selectedGroupCode);
            formData.append("users", JSON.stringify(formattedUsers));

            const importResponse = await axios.post(
                `${process.env.REACT_APP_API_URL}/users-permissions/users/import-group/${selectedGroupCode}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log('import response', importResponse.data);

            // const usersCredentials = formattedUsers.map(u => ({
            //     email: u.email,
            //     password: String(u.password) || "123456",
            // }));

            // await Promise.all(
            //     usersCredentials.map(({ email, password }) =>
            //         axios.post(
            //             `${process.env.REACT_APP_API_URL_VR_EDITOR}/auth/signin`,
            //             {
            //                 email,
            //                 password,
            //             }
            //         ).catch(err => {
            //             console.warn("Signin failed for:", email);
            //         })
            //     )
            // );

            // const emails = usersCredentials.map(u => u.email);
            const emails = formattedUsers.map(u => u.email);

            await axios.post(
                `${process.env.REACT_APP_API_URL}/sync-users/to-vr`,
                // `http://localhost:1337/api/sync-users/to-vr`,
                { emails },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const usersResponse = await axios.post(
                `${process.env.REACT_APP_API_URL_VR_EDITOR}/auth/by-emails`,
                { emails },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const usersFromDb = usersResponse.data;
            console.log('usersFromDb', usersFromDb);

            const openBadgeIds = usersFromDb.map(u => u.openBadgeId);

            if (openBadgeIds.length === 0) {
                throw new Error("Brak użytkowników do dodania do eventów");
            }

            await Promise.all(
                events.map(event =>
                    axios.post(
                        `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/${event.id}/join-many`,
                        { userIds: openBadgeIds },
                        { headers: { Authorization: `Bearer ${token}` } }
                    )
                )
            );

            setResult({
                import: importResponse.data,
                eventsJoined: events.length,
                usersJoined: openBadgeIds.length,
            });

        } catch (err) {
            console.error(err);
            setError(err?.response?.data?.message || err.message || "Import nie powiódł się");
        } finally {
            setLoading(false);
        }
    };

    // const handleInputChange = (e) => {
    //     const file = e.target.files?.[0];
    //     if (file) uploadFile(file);
    // };

    // const handleDrop = (e) => {
    //     e.preventDefault();
    //     setDragActive(false);
    //     const file = e.dataTransfer.files?.[0];
    //     if (file) uploadFile(file);
    // };


    const handleInputChange = (e) => {
        const file = e.target.files?.[0];
        if (file && selectedGroupCode) {
            uploadFile(file, selectedGroupCode);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        const file = e.dataTransfer.files?.[0];
        if (file && selectedGroupCode) {
            uploadFile(file, selectedGroupCode);
        }
    };


    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Import użytkowników z pliku Excel</DialogTitle>

            <DialogContent dividers>
                <Alert severity="info" sx={{ mb: 3 }}>Użytkownicy zostaną dodani do aktualnie wybranej grupy.</Alert>

                <Box display="flex" flexDirection="column" gap={3}>
                    <Dropzone
                        onDragOver={(e) => {
                            e.preventDefault();
                            setDragActive(true);
                        }}
                        onDragLeave={() => setDragActive(false)}
                        onDrop={handleDrop}
                        sx={{
                            borderColor: dragActive ? "#1565c0" : "#1976d2",
                            backgroundColor: dragActive ? "#e3f2fd" : "#f5f5f5",
                        }}
                    >
                        <input
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleInputChange}
                        />

                        {loading ? (
                            <Box>
                                <CircularProgress />
                                <Typography mt={2}>Importowanie...</Typography>
                            </Box>
                        ) : fileName ? (
                            <Typography>
                                Wybrany plik:
                                <br />
                                <strong>{fileName}</strong>
                            </Typography>
                        ) : (
                            <Typography>
                                Przeciągnij plik Excel tutaj
                                <br />
                                lub kliknij aby wybrać
                            </Typography>
                        )}
                    </Dropzone>

                    {result && (
                        <Box>
                            <Alert severity="success">
                                Dodano: {result?.updated} użytkowników
                            </Alert>

                            {result.errorCount > 0 && (
                                <>
                                    <Box mt={2}>
                                        <Alert severity="warning">
                                            Błędy: {result.errorCount}
                                        </Alert>
                                    </Box>

                                    <Box
                                        mt={2}
                                        maxHeight={200}
                                        overflow="auto"
                                        border="1px solid #eee"
                                        borderRadius={1}
                                    >
                                        <List dense>
                                            {result.errors.map((err, index) => (
                                                <React.Fragment key={index}>
                                                    <ListItem>
                                                        <ListItemText
                                                            primary={`Wiersz ${err.row}`}
                                                            secondary={err.error}
                                                        />
                                                    </ListItem>
                                                    <Divider />
                                                </React.Fragment>
                                            ))}
                                        </List>
                                    </Box>
                                </>
                            )}
                        </Box>
                    )}

                    {error && <Alert severity="error">{error}</Alert>}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Zamknij
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImportUsersDialog;
